<template>
  <div>
    <div v-if="showErr" class="center-screen">
      <div :style="cardStyle" :class="`${cardStyle.clientWidth >= 462 ? 'el-card is-always-shadow' : 'el-card'}`">
        <img class="index-logo" src="static/indexnoslus.svg">
        <h4 style="margin-top:70px;color:#E30015">{{server_err_mesage}}</h4>
        <transition name="fade">
          <div v-show="showErr">{{server_err_description}}</div>
        </transition>
      </div>
    </div>
    <div v-else :class="showWindow !=='form' ? 'center-screen' : ''">
      <!-- LOGIN WINDOW -->
      <div v-if="showWindow=='login'" :style="cardStyle" :class="`${cardStyle.clientWidth >= 462 ? 'el-card is-always-shadow' : 'el-card'}`">
        <img class="index-logo" src="static/indexnoslus.svg">
        <h4 v-if="nr_message !== 999" style="margin-top:30px">{{$t("webdocument.msg.login_title")}}</h4>
        <div style="padding: 14px;">
          <div class="bottom clearfix">
            <div style="height:54px">
              <transition-group name="fade">
                <div v-show="showMsg" key="t1" :style="`color:${color[color.set]}`">{{show_message}}</div>
              </transition-group>
            </div>
            <div v-if="nr_message !== 999">
              <div style="margin-top:30px;text-align:left;margin-bottom:5px">
                <b>{{$t("webdocument.lbl.identication_nr")}}</b>
              </div>
              <el-input style="font-size:16px" @keyup.native.enter="(pin > '') ? login() : ''" :placeholder="$t('webdocument.lbl.identication_nr_placeholder')" v-model="pin" clearable></el-input>
              <div style="margin-top:20px;text-align:right">
                <el-button type="danger" :class="`${isDisabled ? 'btn-confirm-disabled' : 'btn-confirm'}`" :style="cardStyle_form.clientWidth >= 850 ? '' : 'width:calc(100%);height:42px;'" :disabled="isDisabled || pin == ''" 
                  @click="login()" :icon="(loginLoading) ? 'el-icon-loading' : ''">
                  {{(loginLoading) ? '' : $t('webdocument.lbl.login')}}
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- FORM WINDOW -->
      <div v-if="showWindow=='form'" style="padding:0px">
        <el-container>
          <el-header style="padding:0px;position:fixed;top:0px;left:0px;right:0px;height:60px;z-index:16;border-bottom:1px solid #e6e6e6;background:white;box-shadow:0 0 12px 0 rgba(47,55,62,0.16)">
            <div style="display:flex;justify-content:space-between;gap:5px;height:40px;margin:10px">
              <!-- LEFT -->
              <div v-if="!$isMobile()" style="width:100px;text-align:left">
                <img style="height:40px" src="static/fooma-logo-text-blue.png">
              </div>
              <div v-else style="width:50px;text-align:left">
                <img style="height:40px" src="static/fooma-logo-blue.png">
              </div>
              <!-- MIDDLE -->
              <div v-if="!$isMobile()" style="font-size:18px;display:flex">
                  <span style="color:#667988;font-weight:bold;line-height:40px">
                    <a @click="prevPage()">
                      <i style="font-weight:bold" class="el-icon-arrow-left"></i>
                    </a>
                    <span style="font-weight:normal;font-size:17px">{{page}} / {{ numPages ? numPages : '∞' }}</span>
                    <a @click="nextPage()">
                      <i style="font-weight:bold" class="el-icon-arrow-right"></i>
                    </a>

                    <el-divider direction="vertical"></el-divider>

                    <a style="margin-left:0px">
                      <el-dropdown @command="handleZoom" trigger="click">
                        <strong>
                          {{ formattedZoom }} %<i style="font-weight:bold" class="el-icon-arrow-down el-icon--right"></i>
                        </strong>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item command="page-width">Fit</el-dropdown-item>
                          <el-dropdown-item command="0.5">50%</el-dropdown-item>
                          <el-dropdown-item command="1">100%</el-dropdown-item>
                          <el-dropdown-item command="1.5">150%</el-dropdown-item>
                          <el-dropdown-item command="2">200%</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </a>
                    <a style="margin-left:10px;" @click="scale -= scale > 0.2 ? 0.1 : 0">
                      <i style="font-weight:bold" class="el-icon-zoom-out" />
                    </a>
                    <a style="margin-left:5px" @click="scale += (scale < 2) ? 0.1 : 0">
                      <i style="font-weight:bold" class="el-icon-zoom-in" />
                    </a>
                  </span>
                  <mq-layout mq='laptop+'>
                    <el-divider direction="vertical"></el-divider>

                    <span style="color:#667988;font-weight:bold;line-height:40px">
                      <a @click="download()">
                        <i style="font-weight:bold" class="el-icon-download" />
                      </a>
                    </span>
                  </mq-layout>
              </div>
              <div v-else />
              <!-- RIGHT -->
              <div>
                <div style="justify-content:right;display:flex;flex-direction:row;gap:15px">
                  <!-- <el-button size="medium" type="danger" @click="declineSignDocument">Odmietnuť</el-button> -->
                  <div style="margin-top:4px">
                    <a v-if="!$isMobile()" @click="scrollToNextSignature('prev')">
                      <i style="font-weight:bold" class="el-icon-arrow-left"></i>
                    </a>
                    <a v-if="!$isMobile()" @click="scrollToNextSignature('next')">
                      <i style="font-weight:bold" class="el-icon-arrow-right"></i>
                    </a>
                    <span style="font-size:14px">
                      <span>{{$t('webdocument.msg.fooma_confirmed_signatures')}}</span>
                      <strong style="margin-left:5px">{{status.confirmed}} / {{status.total}}</strong> 
                      <el-progress size="mini" style="margin-top:4px;" :show-text="false" :percentage="status.percentage"></el-progress>
                    </span>
                  </div>
                  <div v-if="status.confirmed !== status.total">
                     <!-- @click="scrollToNextSignature('first')" -->
                    <el-button type="primary" size="medium" @click="continueToSignDocument">
                      {{$t('webdocument.lbl.confirm_signatures')}}
                    </el-button>
                  </div>
                  <div v-else>
                    <el-button size="medium" type="primary" @click="continueToSignDocument">
                      {{$t('webdocument.lbl.confirm_signatures')}}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </el-header>
          <el-container style="position:absolute;top:60px;left:0px;right:0px;bottom:0px">
            <!-- MAIN -->
            <el-main ref="hm-pdf-main" id="hm-pdf-main" :style="'background:#efefef;padding:10px ' + (($isMobile()) ? '0px' : '40px')">
              <pdf :ref="'pdf_page_' + i" :src="pdfdata" v-for="i in numPages" :key="i" :id="i" :page="i"
                :scale.sync="scale"
                class="hhm-page" :style="($isMobile()) ? 'position:relative;margin:10px 0px' : 'position:relative;margin:15px auto'">
                <template slot="loading">
                  loading...
                </template>
                <template slot="signature">
                  <div :style='pageStyleObj'>
                    <!-- <div v-for="signature in signatures[i - 1]" :key="'w' + signature.id"
                        :style="'position:absolute;background:white;width:20%;height:' + signature.height + ';top:' + signature.topTag + ';left:' + signature.left">
                    </div> -->
                    <div v-for="signature in signatures[i - 1]" :key="signature.id"
                      :id="'signature_' + signature.nr"
                      @click="confirmSignature(signature)"
                      :class="(signature.confirmed) ? 'hm-sign-btn confirmed' : 'hm-sign-btn'"
                      :style="'top:' + signature.top + ';left:' + signature.left">
                      <span :style="'font-size:14px;font-weight:bold;zoom:' + formattedZoom + '%'">
                        {{(signature.confirmed) ? $t('webdocument.lbl.confirmed') : $t('webdocument.lbl.sign')}}
                      </span>
                    </div>
                  </div>
                </template>
              </pdf>
            </el-main>
            <!-- LEFT MENU -->
            <div v-if="!$isMobile()" style="z-index:2;position:relative;top:0px;bottom:0px;box-shadow:0 4px 14px 0 #a4a3a4;overflow:auto;height:100%">
              <el-aside style="width:200px;border-left:1px solid #eee;height:100%">
                <div style="padding:0 16px;">
                  <pdf :src="pdfdata2" :ref="'pdf' + i" v-for="i in numPages2" :key="i" :id="'t_' + i" :page="i"
                      :scale.sync="scale2"
                      :class="(page === i) ? 'hm-thumbnail-pdf hm-active' : 'hm-thumbnail-pdf'"
                      :annotation="true"
                      :resize="true">
                      <template slot="loading">
                        loading...
                      </template>
                      <template slot="signature">
                        <div @click="showPage(i)" class="hm-page" :style='thumbStyleObj'>
                          <div :class="(page === i) ? 'hm-page-number hm-active' : 'hm-page-number'">
                            {{i}}
                          </div>
                          <div v-for="signature in signatures[i - 1]" :key="signature.id"
                            :id="'signature_' + signature.nr"
                            :class="(signature.confirmed) ? 'hm-sign-btn confirmed' : 'hm-sign-btn'"
                            :style="'position:absolute;top:' + signature.top + ';left:' + signature.left">
                            <span :style="'font-size:12px;font-weight:bold;zoom:' + (scale2 * 100) + '%'">
                              {{(signature.confirmed) ? $t('webdocument.lbl.confirmed') : $t('webdocument.lbl.sign')}}
                            </span>
                          </div>
                        </div>
                      </template>
                  </pdf>
                </div>
              </el-aside>
            </div>
          </el-container>
        </el-container>
      </div>
      <!-- DONE -->
      <div v-if="showWindow === 'done' || showWindow === 'cancel' || showWindow === 'saving' || showWindow === 'error'" :style="cardStyle" :class="`${cardStyle.clientWidth >= 462 ? 'el-card is-always-shadow' : 'el-card'}`">
          <img class="index-logo" src="static/indexnoslus.svg">
          <h4 style="margin-top:30px">
            <span v-if="showWindow === 'saving'">
              {{$t('webdocument.msg.sign_saving_title')}}
            </span>
            <span v-if="showWindow === 'done'">
              {{$t('webdocument.msg.sign_success_title')}}
            </span>
            <span v-if="showWindow === 'cancel'">
              {{$t('webdocument.msg.sign_cancel_title')}}
            </span>
            <span v-if="showWindow === 'error'">
              {{$t('webdocument.msg.sign_failed')}}
            </span>
          </h4>
          <div style="padding: 14px;">
            <div class="bottom clearfix">
              <div style="height:54px">
                <span v-if="showWindow === 'saving'">
                  <i class='el-icon-loading'></i>
                  {{$t('webdocument.msg.sign_saving')}}
                </span>
                <spn v-if="showWindow === 'done'">
                  {{$t('webdocument.msg.sign_success')}}
                </spn>
                <spn v-if="showWindow === 'cancel'">
                  {{$t('webdocument.msg.sign_cancel')}}
                </spn>
                <span v-if="showWindow === 'error'">
                  
                </span>
                
              </div>
            </div>
          </div>
      </div>
    </div>

    <hm-signature v-if="signDialogVisible" :show="signDialogVisible" @close="signDialogVisible = false" @save="save"/>
  </div>
</template>

<script>
/* eslint-disable camelcase */
/* eslint-disable brace-style */
/* eslint-disable one-var */
/* eslint-disable standard/object-curly-even-spacing */
import {validateLink, authLink, trackSignClick, signDocument} from '@/api/fooma'
import validity from '@/components/HMEmployeeForm/mixins/validity'
import pdfvuer from 'pdfvuer'
import vueSignature from 'vue-signature'
import HMSignature from '@/components/HMSignature'

export default {
  name: 'WebDocument',
  mixins: [validity],
  components: {
    pdf: pdfvuer,
    'hm-signature': HMSignature,
    vueSignature
  },
  data () {
    return {
      loginLoading: false,
      signDialogVisible: false,
      signature_tag: '«%podpis»',
      counter: 0,
      scrollSignature: 0,
      pdfLoaded: false,
      loadings: [],
      signatures: [
        []
      ],
      status: {
        total: 0,
        confirmed: 0,
        percentage: 0,
        signatures: []
      },
      pageStyleObj: undefined,
      thumbStyleObj: undefined,
      document_id: undefined,
      expiration: undefined,

      list: false, // ked sa nastavi na true, zacnu sa nacitavat ciselniky
      showErr: false,
      server_err_mesage: '',
      server_err_description: '',
      isLoading: true,
      showMsg: false,
      showSendPin: true,
      disableSendPin: false,
      cardStyle: { padding: '0px', width: '482px', minheight: '400px', clientWidth: 482 },
      cardStyle_form: {
        'padding': '0px',
        'width': 'calc(100% - 60px)',
        'max-width': '900px',
        'clientWidth': 850
      },
      pin: undefined,
      listMessage: [
        this.$t('webdocument.msg.list0'),
        this.$t('webdocument.msg.list2'),
        this.$t('webdocument.msg.list3'),
        this.$t('webdocument.msg.list4')
      ],
      nr_message: 0,
      show_message: '',
      color: {
        set: 'normal',
        normal: '#303133',
        error: '#E30015'
      },
      msg_timeout: undefined,
      isDisabled: true,
      showWindow: 'login', // 'login', 'form', 'signature', 'done'
      dataForm: {
        signatures: {
          employee: []
        }
      },
      savingBtn: false, // loading na tlacitku ULOZIT
      disableBtn: true, // povoli/blokuje tlacitko ULOZIT
      documentID: this.$route.params.documentID,
      page: 1,
      numPages: 0,
      numPages2: 0,
      pdfdata: undefined,
      pdfdata2: undefined,
      errors: [],
      scale: 'page-width',
      scale2: 'page-width',
      sign_list: [{
        employee: {}
      }], // zoznam stran s podpismi
      sign_remains: [], // strany kde sa vyzaduje podpis
      sign_success: [], // zapise sa cislo stranky ktora je uz podpisana
      isLoaded: false, // az ked sa vykresli pdf, nastavi sa na hodnotu true a nasledne sa zobrazia podpisove tlacitka
      isEmpty: true, // nastavi sa na true ak sa nieco nakreslilo do podpisu
      window_width: 0, // sirka okna prehliadaca
      canvas_width: 875, // sirka canvas podpisu
      canvas_height: 350, // vyska canvas podpisu
      penColor: '#0E0401',
      signOpt: {
        penColor: '#0E0401',
        backgroundColor: 'rgb(0,0,0,0)'
      },
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        '#c72577'
      ]
    }
  },
  computed: {
    formattedZoom () {
      if (this.$isMobile()) {
        return Number.parseInt(Number.parseFloat(this.scale)* 100)
      }
      else {
        return Number.parseInt(Number.parseFloat(this.scale).toFixed(1) * 100)
      }
    }
  },
  watch: {
    'status.confirmed': function (val) {
      this.status.percentage = this.status.confirmed / this.status.total * 100
    },
    pin: function (newVal) {
      if (newVal.length > 0) {
        this.showSendPin = false // schovaj btn poslat PIN znovu
        if (!this.validNumeric(newVal)) {
          if (this.msg_timeout) {
            clearTimeout(this.msg_timeout)
          }
          this.showMsg = false
          this.msg_timeout = setTimeout(() => {
            this.nr_message = 1
            this.color.set = 'error'
            this.show_message = this.listMessage[this.nr_message]
            this.showMsg = true
          }, 600)
        } else {
          this.isDisabled = false
          this.confirmValid()
        }
      } else {
        this.confirmValid()
        this.showSendPin = true // ukaz btn poslat PIN znovu
        this.isDisabled = true
      }
    },
    window_width: function (valWidth) {
      console.log('window width resize')
      this.scale = 'page-width'
      // (!this.$isMobile()) ? 1 : 'page-width'
    },
    scale2: function (newVal) {
      var dataPages = this.$el.getElementsByClassName('hm-thumbnail-pdf')
      const self = this
      setTimeout(function() {
        self.thumbStyleObj = {
          width: dataPages[0].offsetWidth + 'px',
          height: dataPages[0].offsetHeight + 'px'
        }
      })
    },
    scale: function (newVal) {
      console.log('scale change to', newVal)
      var dataPages = this.$el.getElementsByClassName('page')
      const self = this
      setTimeout(function () {
        self.pageStyleObj = {
          background: 'transparent',
          position: 'absolute',
          'z-index': 50,
          inset: '0px',
          margin: 'auto',
          width: dataPages[0].offsetWidth + 'px',
          height: dataPages[0].offsetHeight + 'px'
        }
      })
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.handleWindowSize(window.innerWidth)
    })
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.handleWindowSize(window.innerWidth)
    })
  },
  created () {
    this.$i18n.locale = 'sk'

    this.listMessage = [
      this.$t('webdocument.msg.list0'),
      this.$t('webdocument.msg.list2'),
      this.$t('webdocument.msg.list3'),
      this.$t('webdocument.msg.list4')
    ]

    this.document_id = this.$route.params.document_id
    this.expiration = this.$route.params.expiration

    this.window_width = window.innerWidth
    this.handleWindowSize(window.innerWidth)
    this.show_message = this.listMessage[this.nr_message]
    if (this.validLink()) { // kontrola validity na klientskej strane
      this.validateLink()
    }
    else {
      this.handleError({status: 500, data: {error: {err_code: 2}}})
      this.isLoading = false
    }
    setTimeout(() => {
      this.showMsg = true
    }, 800)

    // setTimeout(() => {
    //   this.scale = this.$isMobile() ? 'page-width' : 1
    //   console.log('[scale2]', this.scale)
    // }, 1500)
  },
  methods: {
    confirmSignature (signature) {
      if (signature.confirmed) {
        signature.confirmed = false
        this.status.confirmed--
      }
      else {
        signature.confirmed = true
        this.scrollSignature = signature.nr
        this.status.confirmed++
        if (this.status.confirmed < this.status.total) {
          this.scrollToNextSignature('next')
        }
        else {
          this.continueToSignDocument()
        }
      }
    },
    scrollToNextSignature (direction) {
      if (direction === 'prev') {
        this.scrollSignature = (this.scrollSignature > 1) ? (this.scrollSignature - 1) : 1
      }
      if (direction === 'next') {
        this.scrollSignature = (this.scrollSignature < this.status.total) ? (this.scrollSignature + 1) : this.status.total
      }
      // scroluj k prvemu nepodpisanemu podpisu
      if (direction === 'first') {
        this.scrollSignature = 1
      }

      document.getElementById('signature_' + this.scrollSignature).scrollIntoView()
    },
    nextPage () {
      this.page = (this.page < this.numPages) ? (this.page + 1) : this.page
      this.scrollToPage()
    },
    prevPage () {
      this.page = (this.page > 1) ? (this.page - 1) : this.page
      this.scrollToPage()
    },
    showPage (page) {
      this.page = page
      this.scrollToPage()
    },
    scrollToPage () {
      const p = this.page
      if (window.pageYOffset <= this.findPos(document.getElementById(p)) || (document.getElementById(p + 1) && window.pageYOffset >= this.findPos(document.getElementById(p + 1)))) {
        document.getElementById(p).scrollIntoView()
      }
      const
        t = 't_' + this.page,
        tt = 't_' + (this.page + 1)
      if (window.pageYOffset <= this.findPos(document.getElementById(t)) || (document.getElementById(tt) && window.pageYOffset >= this.findPos(document.getElementById(tt)))) {
        document.getElementById(t).scrollIntoView()
      }
    },
    handleZoom (value) {
      this.scale = value
    },
    thumbnailClick () {
      console.log('thumbnailClicked', page)
    },
    handleDisabledBtnSave () {
      this.disableBtn = true
    },
    handleWindowSize (p_width) {
      // *** nastavenia pre login obrazovku
      this.cardStyle.clientWidth = p_width // nastav skutocnu sirku obrazovky
      this.cardStyle.width = p_width < 482 ? 'calc(100% - 30px)' : '482px' // okraje login okna pri desktope a mobile
      this.cardStyle.shadow = p_width > 482 ? 'always' : 'none' // desktop => zobraz tien pod el-card : maly displej(mobil) => vypni tien pod el-card
      this.cardStyle.padding = p_width > 850 ? '30px' : '40px 20px 40px 20px' // desktop => je padding 30px : maly displej(mobil) => je padding 0px
      // *** nastavenia pre formular
      this.cardStyle_form.clientWidth = p_width // nastav skutocnu sirku obrazovky
      this.cardStyle_form.width = p_width < 482 ? 'calc(100% - 30px)' : '850px' // okraje login okna pri desktope a mobile
      this.cardStyle_form.shadow = p_width > 850 ? 'always' : 'none' // desktop => zobraz tien pod el-card : maly displej(mobil) => vypni tien pod el-card
      this.cardStyle_form.padding = p_width > 850 ? '30px' : '20px' // desktop => je padding 30px : maly displej(mobil) => je padding 0px
      // ---
      this.window_width = p_width
      // ---
    },
    confirmValid () {
      // eslint-disable-next-line eqeqeq
      if (this.nr_message == 0) return
      if (this.msg_timeout) {
        clearTimeout(this.msg_timeout)
      }
      this.showMsg = false
      this.msg_timeout = setTimeout(() => {
        this.nr_message = 0
        this.color.set = 'normal'
        this.show_message = this.listMessage[this.nr_message]
        this.showMsg = true
      }, 600)
    },
    validLink () { // je linka este platna?
      if (this.expiration) {
        let expiration = this.expiration
        let nowtimestamp = this.$moment().valueOf()
        if (nowtimestamp < expiration) {
          return true // validna
        } 
        else {
          return false // nevalidna
        }
      } 
      else {
        return false // nevalidna
      }
    },
    validateLink () { // overuje odkaz a posle PINkod
      validateLink({
        document_id: this.document_id,
        expiration: this.expiration
      }).then((response) => {
        // HOTOVO
        this.isLoading = false
      })
        .catch((err) => {
          this.isLoading = false
          console.error(`[webDocument.vue] authDocument ! err`, err)
          this.handleError(err)
        })
    },
    login () {
      this.loginLoading = true
      this.isDisabled = true
      authLink({
        document_id: this.document_id,
        expiration: this.expiration,
        pin: this.pin
      }).then((response) => {
        this.loginLoading = false
        this.isDisabled = false
        this.showWindow = 'form'
        var _ = require('lodash')
        this.dataForm = _.cloneDeep(response.data.data)
        this.getPdf()     
      })
        .catch((err) => {
          console.error(`[webDocument.vue] detailDocument ! err`, err)
          this.loginLoading = false
          this.isDisabled = false
          this.handleError(err)
        })
    },
    continueToSignDocument () {
      // this.showWindow = 'signature'
      this.signDialogVisible = true
      trackSignClick(this.document_id)
    },
    handleError (err) {
      console.log('handleError', err)
      // chyby sa zobrazia v login okne nad inputom
      if (err.status === 500) {
        this.nr_message = (err.data.error === 'Platnost linky vypršala') ? 999 : 2 // docasne riesenie
        this.show_message = err.data.error
        this.color.set = 'error'
      }
      
      if (this.nr_message !== 2) { // chyba zmizne za 7 sek
        setTimeout(() => {
          this.nr_message = 0
          this.show_message = this.listMessage[this.nr_message]
          this.color.set = 'normal'
        }, 7000)
      }
      // ---
      // chyby sa zobrazia ako samostany el-card(okienko)
      if (err.toString() === 'Network Error') {
        this.showErr = true
        this.server_err_mesage = this.$t('webdocument.msg.err_link_title')
        this.server_err_description = this.$t('webdocument.msg.err_link_desc')
        setTimeout(() => {
          this.showErr = false
        }, 5000)
      }
      if (err.status === 500) {
        console.log('error 500', err)
        if (err.data && err.data.error.err_code === 2) { // vyprsalo casove okno, The link has expired.
          this.showErr = true // zobraz samostatne okienko s chybou
          this.server_err_mesage = this.$t('webdocument.msg.err_link_title1')
          this.server_err_description = this.$t('webdocument.msg.err_link_desc1')
        }
        if (err.data && err.data.error.err_code === 3) { // blby odkaz, Illegal link duration manipulation!
          this.showErr = true // zobraz samostatne okienko s chybou
          this.server_err_mesage = this.$t('webdocument.msg.err_link_title2')
          this.server_err_description = this.$t('webdocument.msg.err_link_desc2')
        }
        if (err.data && err.data.error.err_code === 4) { // data formularu uz schvalil uzivatel
          this.showErr = true // zobraz samostatne okienko s chybou
          this.server_err_mesage = this.$t('webdocument.msg.err_link_title3')
          this.server_err_description = this.$t('webdocument.msg.err_link_desc3')
        }
        if (err.data && err.data.error.err_code === 5) { // ostatne chyby
          this.showErr = true // zobraz samostatne okienko s chybou
          this.server_err_mesage = this.$t('webdocument.msg.err_link_title4')
          this.server_err_description = this.$t('webdocument.msg.err_link_desc4') // err.data.error.err_message
        }
        // update - saveForm => zobrazi sa notify okno
        if (err.data && err.data.error.err_code === 6) { // ostatne chyby pri ukladani
          this.$notify({
            title: this.$t('webdocument.lbl.title'),
            message: this.$t('webdocument.msg.err_not_save'),
            type: 'error'
          })
        }
      }
    },
    handle_pdf_link: function (params) {
      console.log('handle_pdf_link', params)
      // Scroll to the appropriate place on our page - the Y component of
      // params.destArray * (div height / ???), from the bottom of the page div
    },
    findPos (obj) {
      return obj.offsetTop
    },
    getPdf () {
      this.pdfdata = pdfvuer.createLoadingTask(this.dataForm.content)
      this.pdfdata.then(pdf => {
        this.numPages = pdf.numPages

        console.log('pages = ', pdf.numPages)

        for (var i = 0; i < this.numPages; i++) {
          this.signatures.push([])
          this.loadings.push(false)
        }
        for (var j = 1; j <= this.numPages; j++) {
          this.tPdf(j)
        }
        const self = this
        const main = document.getElementById('hm-pdf-main')
        main.onscroll = function () {
          changePage()
        }

        const el = this.$refs['hm-pdf-main'].$el

        function changePage () {
          const
            scrollTop = el.scrollTop - 30,
            height = innerHeight - 60,
            startScreenY = parseInt(scrollTop),
            stopScreenY = parseInt(height + scrollTop)

          var i = 1, count = Number(self.numPages), current, cp = {}

          do {
            current = document.getElementById(i)

            cp = {
              start: parseInt((current.offsetHeight * i) - current.offsetHeight) + height / 2,
              stop: parseInt(current.offsetHeight * i) + height / 2
            }

            // console.table({
            //   i: i,
            //   from: startScreenY,
            //   to: stopScreenY,
            //   start: cp.start,
            //   end: cp.stop,
            //   A: (cp.start <= startScreenY && cp.stop >= startScreenY && cp.stop <= stopScreenY),
            //   B: (cp.start >= startScreenY && cp.stop <= stopScreenY),
            //   C: (cp.start >= startScreenY && cp.start <= stopScreenY && cp.stop >= stopScreenY),
            //   D: (cp.start <= startScreenY && cp.stop >= stopScreenY)
            // })

            if ((cp.start <= startScreenY && cp.stop >= startScreenY && cp.stop <= stopScreenY) ||
                (cp.start >= startScreenY && cp.stop <= stopScreenY) ||
                (cp.start >= startScreenY && cp.start <= stopScreenY && cp.stop >= stopScreenY) ||
                (cp.start <= startScreenY && cp.stop >= stopScreenY)) {
              self.page = i
            }

            i++
          } while (i < count)
          current = document.getElementById(i)
          cp = {
            start: parseInt((current.offsetHeight * i) - current.offsetHeight) + height / 2,
            stop: parseInt(current.offsetHeight * i) + height / 2
          }
          if ((cp.start <= startScreenY && cp.stop >= startScreenY && cp.stop <= stopScreenY) ||
              (cp.start >= startScreenY && cp.stop <= stopScreenY) ||
              (cp.start >= startScreenY && cp.start <= stopScreenY && cp.stop >= stopScreenY) ||
              (cp.start <= startScreenY && cp.stop >= stopScreenY)) {
            self.page = i
          }
        }
      })

      this.pdfdata2 = pdfvuer.createLoadingTask(this.dataForm.content)
      this.pdfdata2.then(pdf => {
        this.numPages2 = pdf.numPages
      })
    },
    tPdf (p) {
      let interval = []
      interval[p] = setInterval(() => {
        console.log('waiting for pdf_page_' + p)
        if (this.$refs['pdf_page_' + p]) {
          console.log('available pdf_page_' + p)
          this.renderingDone(p)
          clearInterval(interval[p])
        }
      }, 50)
    },
    renderingDone (p) {
      let interval = []
      console.log('rendering start for', p, this.$refs['pdf_page_' + p])
      // const textLayer = this.$refs['pdf_page_' + p][0].pdfViewer.textLayer
      console.log('[',p,'] renderingState', this.$refs['pdf_page_' + p][0].pdfViewer.renderingState)
      interval[p] = setInterval(() => {
        // textLayer.renderingDone === true
        if (this.$refs['pdf_page_' + p][0].pdfViewer.renderingState === 3) {
          this.scanPdf(p)
          clearInterval(interval[p])
          console.log('rendering done', p, this.$refs['pdf_page_' + p][0].pdfViewer.renderingState)
          if (this.numPages === p) {
            if (!this.$isMobile()) {
              if (this.scale > 1) {
                this.scale = 1
              }
            }
          }
        }
      }, 50)
    },
    scanPdf (p) {
      const
        textLayer = this.$refs['pdf_page_' + p][0].pdfViewer.textLayer,
        stringArray = textLayer.textContentItemsStr

      for (var i = 0; i < stringArray.length; i++) {
        const value = stringArray[i].trim()
        if (value === '«%podpis»') {
          const spanHtml = textLayer.textDivs[i]
          this.counter++
          this.signatures[p - 1].push({
            id: i,
            left: this.pixelLeftToPercentage(spanHtml.style.left) + '%',
            top: (this.pixelTopToPercentage(spanHtml.style.top) - 1) + '%',
            topTag: this.pixelTopToPercentage(spanHtml.style.top) + '%',
            height: spanHtml.style['font-size'],
            confirmed: false,
            nr: this.counter
          })
          this.status.signatures.push({
            top: (this.pixelTopToPercentage(spanHtml.style.top) - 1) + '%',
            page: p,
            nr: this.counter
          })
          this.status.total++
        }
      }
    },
    pixelLeftToPercentage (px) {
      px = parseFloat(px.replace('px', ''))
      let width = parseFloat(this.pageStyleObj.width.replace('px', ''))
      return parseFloat(px / width * 100)
    },
    pixelTopToPercentage (px) {
      px = parseFloat(px.replace('px', ''))
      let height = parseFloat(this.pageStyleObj.height.replace('px', ''))
      return parseFloat(px / height * 100)
    },
    percentageTopToPixel (percentage) {
      percentage = parseFloat(percentage.replace('%', ''))
      let height = parseFloat(this.pageStyleObj.height.replace('px', ''))
      return parseFloat(percentage * height / 100)
    },
    cancelSignDocument () {
      this.showWindow = 'cancel'
    },
    save (signature) {
      console.log('save signature')
      this.showWindow = 'saving'
      let headers = {
        'X-PIN': this.pin
      }
      // var signature = this.$refs.signature.save()
      
      signDocument(this.document_id, {content: signature}, headers).then((response) => {
        console.log(response.data)
        this.showWindow = 'done'
      }).catch((err) => {
        console.error(err)
        this.showWindow = 'error'
        // this.$notify({
        //   title: this.$t('lbl.warning'),
        //   message: this.$t('webdocument.msg.sign_failed'),
        //   type: 'warning',
        //   duration: 5000
        // })
      })
    }
  }
}
</script>

<style>
  .el-aside .hm-sign-btn,
  .el-main .hm-sign-btn {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    border-radius: 3px;
    border: 0px solid #F56C6C;
    background: #F56C6C;
    width: 20%;
    height: 4%;
    color: white;
    scroll-margin: 100px;
  }

  .el-aside .hm-sign-btn {
    border-radius: 1px;
  }

  .el-main .hm-sign-btn:hover {
    background: #f35555;
    color:white
  }

  .el-aside .hm-sign-btn.confirmed,
  .el-main .hm-sign-btn.confirmed {
    background: #409EFF;
    border-color: #409EFF;
    color:white;
  }

  .el-header a {
    padding: 0 4px;
  }

  .el-header a:hover {
    color: #48535c;
    background: #e5e7e9;
    border-radius: 4px;
    padding: 0 4px;
  }

  .el-header .el-dropdown strong:hover {
    color: #48535c;
  }

  .el-main .page {
    margin:auto;
  }

  .el-main .hm-page {
    margin: 20px auto;
    /* box-shadow:0 0 12px 0 rgba(47,55,62,0.16); */
  }

  .el-main .page .canvasWrapper canvas {
    box-shadow: 0 2px 8px 0 rgba(47, 55, 62, 0.1);
  }

  .el-aside .hm-thumbnail-pdf {
    cursor:pointer;
    width:100%;
    border:1px solid #ccc;
    margin-bottom:10px;
    padding:5px 0;
    position: relative;
    margin-top: 10px;
    cursor: pointer
  }
  .el-aside .hm-thumbnail-pdf.hm-active {
    border:1px solid #409EFF;
  }
  .el-aside .hm-thumbnail-pdf:hover {
    box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.2);
  }

  .el-aside .hm-page {
    z-index: 200;
    position: absolute;
    inset: 0px;
    margin: auto;
    background: transparent;
  }

  /* .el-main .hm-page {
    z-index: 180;
    position: absolute;
    inset: 0px;
    margin: auto;
    background: transparent;
  } */

  .el-aside .hm-page .hm-page-number {
    background: #ccc;
    width: 30px;
    height: 30px;
    position: absolute;
    inset: 0px;
    padding: 4px;
  }

  .el-aside .hm-page .hm-page-number.hm-active {
    background: #409EFF;
    color: white;
  }

.center-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  min-height: 90vh;
}
.index-logo {
  height: 40px;
  width: auto;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.btn-confirm-disabled {
  background-color:#e19091 !important;
  border: 0px;
  color:whitesmoke !important;
}
.btn-confirm-disabled:hover {
  background-color:#eb4c4e;
  color:whitesmoke;
}
.btn-confirm {
  background-color:#E30015;
  border: 0px;
  color:whitesmoke;
}
.btn-confirm:hover {
  background-color:hsla(354, 100%, 45%, 0.822);
  color:whitesmoke;
}
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.box-card {
  text-align:left;
}
.control-mini-panel {
  display:block;
  background-color:#08080875;
  position:fixed;
  bottom:10px;
  left:50px;
  right:50px;
  height:50px;
  z-index:100;
  border-radius: 5px;
  border: 1px solid #EAEEF4;
  text-align: left;
  padding:5px;
}
.page-big {
  font-size: 20px;
}
.page-small {
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/FoomaWordDocument/index.vue